module.exports = __webpack_public_path__ + "static/media/black-girls-code.7788abd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/logos/black-girls-code.png
// module id = 350
// module chunks = 0